/* eslint-disable import/prefer-default-export */

export const CVSS_PATTERNS = {
  'CVSS v2.0': /^AV:[NAL]\/AC:[LH]\/Au:[NSM]\/C:[CNP]\/I:[CNP]\/A:[CNP]$/,
  'CVSS v3.1': /^CVSS:3\.1\/AV:(N|A|L|P)\/AC:(L|H)\/PR:(N|L|H)\/UI:(N|R)\/S:(U|C)\/C:(N|L|H)\/I:(N|L|H)\/A:(N|L|H)$/,
  'CVSS v4.0': /^CVSS:4\.0\/AV:(N|A|L|P)\/AC:(L|H)\/AT:(N|P)\/PR:(N|L|H)\/UI:(N|A|R|P)\/VC:(N|L|H)\/VI:(N|L|H)\/VA:(N|L|H)\/SC:(N|L|H)\/SI:(N|L|H)\/SA:(N|L|H)(\/E:(X|U|P|A))?(\/CR:(L|M|H))?(\/IR:(L|M|H))?(\/AR:(L|M|H))?(\/MAV:(N|A|L|P))?(\/MAC:(L|H))?(\/MAT:(N|P))?(\/MPR:(N|L|H))?(\/MUI:(N|P|A))?(\/MVC:(N|L|H))?(\/MVI:(N|L|H))?(\/MVA:(N|L|H))?(\/MSC:(N|L|H))?(\/MSI:(N|L|H|S))?(\/MSI:(N|L|H|S))?(\/MSA:(N|L|H|S))?(\/S:[A-Z])?(\/AU:[A-Z])?(\/R:[A-Z])?(\/V:[A-Z])?(\/RE:[A-Z])?(\/U:[A-Za-z]+)?$/
};

export const CVSS_TYPES = {
  'CVSS v2.0': 'cvss2',
  'CVSS v3.1': 'cvss3',
  'CVSS v4.0': 'cvss4'
};
